<template>
    <div class="your-order">
        <div>
            <h2 class="your-order__title">{{ $t("YourOrder.your_order") }}</h2>
            <OrderRow :label="$t('General.status')" :data="currentOrder.status" :active="currentOrder.active" />
            <OrderRow :label="$t('General.packages')" :data="currentOrder.packages" />
        </div>
        <div class="your-order__buttons">
            <TotemButton color="secondary" size="medium" :label="$t('YourOrder.change_order')" />
            <TotemButton color="secondary" size="medium" :label="$t('YourOrder.change_password')" />
            <TotemButton color="primary" size="medium" :label="$t('YourOrder.cancel_order')" />
        </div>
    </div>
</template>

<script>
    import OrderRow from 'components/user/orderinfo/OrderRow'
    import { mapGetters } from 'vuex'

    export default {
        components: {
            OrderRow
        },
        computed: {
            ...mapGetters({
                currentOrder: 'User/getCurrentOrder',
                orderHistory: 'User/getOrderHistory'
            })
        },
        created () {
            this.$store.dispatch('User/loadCurrentOrder')
        }
    }
</script>

<style lang="scss" scoped>
    .your-order {
        display: flex;
        justify-content: space-between;
        background: $white;
        border: 1px solid $quill_gray;
        padding: 20px;
        margin: 0 0 20px;

        &__title {
            margin: 0 0 20px;
        }

        &__buttons {
            display: flex;
            flex-direction: column;
            width: 200px;

            .totem-button {
                margin: 5px 0;
            }
        }
    }
</style>
